import { useCallback, useState, useEffect } from 'react';
import Spinner from '../../../../../../components/Spinner/Spinner';
import MaterialItem from '../MaterialItem/MaterialItem';

import './MaterialDropdownsList.scss';
import { useFormikContext } from 'formik';
import { IFormikForm } from '../ModalMaterial/FormikMaterial';
import { useAppSelector } from '../../../../../../reduxService/hooks';
import { selectProject } from '../../../../selector/conversion';
import { IMaterialResponse, IPhysicalDataResponse } from '../../../../../api/IApiResponse';
import { MaterialStatus, Usage } from '../../../../../enum/Material';
import { isAdminUser } from '../../../../../store/user/utils';
import { selectMaterial } from '../../../../../store/material/materialSlice';

type Props = {};

export const MaterialList = (props: Props) => {
    const { values, setFieldValue } = useFormikContext<IFormikForm>();
    const [selected, setSelected] = useState(values[values.sectorChannel].materialId);
    const materials = useAppSelector(selectMaterial);
    const project = useAppSelector(selectProject);

    const handleMaterialClick = useCallback(
        async (material: IMaterialResponse, withPD?: IPhysicalDataResponse) => {
            setFieldValue(`${values.sectorChannel}.materialId`, material.id);
            setSelected(material.id);
            const physicalData = material?.physicalData;
            if (physicalData) {
                if (physicalData.length > 0) {
                    let pdDefault = physicalData.find(pd => pd.isDefault);
                    let physicalDataToSpread = physicalData[0];
                    if (!!pdDefault?.id) {
                        physicalDataToSpread = pdDefault;
                    }
                    let pdToSpread = !!withPD ? withPD : physicalDataToSpread;
                    if (material.id === values[values.sectorChannel].material?.id && !pdToSpread.rockD50 && values[values.sectorChannel].rockD50) {
                        pdToSpread = {
                            ...pdToSpread,
                            rockD50: values[values.sectorChannel].rockD50,
                            thickness: values[values.sectorChannel].thickness,
                            allowShearStress: values[values.sectorChannel].allowShearStress,
                        };
                    }
                    setFieldValue(`${values.sectorChannel}`, { ...pdToSpread });
                    setFieldValue(`${values.sectorChannel}.combinationPD`, pdToSpread.id);
                    setFieldValue(`${values.sectorChannel}.physicalData`, physicalData);
                    setFieldValue(`${values.sectorChannel}.isVegetated`, material.isVegetated);
                    setFieldValue(`${values.sectorChannel}.material`, material);
                    setFieldValue(`${values.sectorChannel}.category`, material.category);
                }
            }
        },
        [values.sectorChannel],
    );
    useEffect(() => {
        if (!materials.pending && !materials.initialState) {
            let sect = project.data?.geometry?.find(geo => geo.channel === values.sectorChannel);
            if (!!sect && !!sect.id) {
                let usage = sect.material?.usage;
                let idToSearch = usage === Usage.Base ? sect.material?.id : sect.material?.baseMaterialId;
                let findedMat = materials.data?.find(data => data.id === idToSearch);
                if (!!findedMat) {
                    let localData = values[values.sectorChannel];

                    let findedCombo = findedMat.physicalData?.find(data => {
                        let check = data.thickness === localData.thickness && data.rockD50 === localData.rockD50;
                        if (!!data.cu) return check && data.cu === localData.cu;
                        else return check;
                    });
                    handleMaterialClick(findedMat, findedCombo);
                } else {
                    if (!!materials.data && materials.data.length > 0) {
                        handleMaterialClick(materials.data[0]);
                    }
                }
            }
        }
    }, [materials, values.sectorChannel]);

    return (
        <div className='w-35'>
            {!materials.initialState && !materials.pending ? (
                <div className='material-list-container scroll'>
                    {materials.data!.map(material => {
                        if (material.status === MaterialStatus.Public || isAdminUser()) {
                            return <MaterialItem key={material.id} selected={selected === material.id} material={material} onClick={() => handleMaterialClick(material)} />;
                        }
                    })}
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    );
};
